// Ensures inline, muted autoplay on Safari/iOS for theme videos
(function () {
  function ensureAttributes(video) {
    if (!video) return;
    try {
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
      if (!video.hasAttribute('preload')) {
        video.setAttribute('preload', 'metadata');
      }
    } catch (_) {}
  }

  function tryPlay(video) {
    if (!video) return;
    const play = video.play && video.play.bind(video);
    if (typeof play === 'function') {
      play().catch(function () {
        // Ignore; Safari may require a gesture — we'll hook one below
      });
    }
  }

  function setupObserver(video) {
    if (!('IntersectionObserver' in window)) {
      tryPlay(video);
      return;
    }
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          tryPlay(video);
        }
      });
    }, { threshold: 0.1 });
    io.observe(video);
  }

  function init() {
    var videos = document.querySelectorAll(
      [
        // Common homepage sections containing videos
        '#MainContent .hero__media video',
        '#MainContent .section-full-width-banner__media video',
        '#MainContent .section-interactive-banner__media video',
        // Fallback: any video in MainContent. Product card videos are excluded:
        // they play only on hover / when a card is at rest, which
        // product-card-video.js controls.
        '#MainContent video:not([data-card-video])'
      ].join(', ')
    );

    if (!videos.length) return;

    videos.forEach(function (video) {
      ensureAttributes(video);
      setupObserver(video);
    });

    // User-gesture fallback (iOS Safari) — first touch/click tries to play all muted videos
    var resumed = false;
    function resumeAll() {
      if (resumed) return;
      resumed = true;
      videos.forEach(tryPlay);
      window.removeEventListener('touchstart', resumeAll, { passive: true });
      window.removeEventListener('pointerdown', resumeAll, { passive: true });
      window.removeEventListener('click', resumeAll, true);
    }
    window.addEventListener('touchstart', resumeAll, { passive: true });
    window.addEventListener('pointerdown', resumeAll, { passive: true });
    window.addEventListener('click', resumeAll, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


